// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeChangeOrigin {
  Unknown = "UNKNOWN",
  BackOffice = "BACK_OFFICE",
  Eshop = "ESHOP",
  Distributor = "DISTRIBUTOR",
  VehicleRegister = "VEHICLE_REGISTER",
}
export default ChargeChangeOrigin;
